// Bridge between gameStore's view state and React Router
// Keeps both in sync: view changes → URL updates, URL changes → view updates

import type { AppView } from '../store/gameStore';

/** Map store views to URL paths */
const VIEW_TO_PATH: Record<AppView, string> = {
  home: '/',
  config: '/play',
  lobby: '/lobby',
  versus: '/versus',
  game: '/game',
  results: '/results',
  profile: '/profile',
  leaderboard: '/leaderboard',
  admin: '/sys/wotgate',
};

/** Map URL paths back to store views */
const PATH_TO_VIEW: Record<string, AppView> = {
  '/': 'home',
  '/play': 'config',
  '/lobby': 'lobby',
  '/versus': 'versus',
  '/game': 'game',
  '/results': 'results',
  '/profile': 'profile',
  '/leaderboard': 'leaderboard',
};

/** Get URL path for a given view */
export function viewToPath(view: AppView): string {
  return VIEW_TO_PATH[view] || '/';
}

/** Get store view for a given URL path (returns null for admin sub-routes) */
export function pathToView(pathname: string): AppView | null {
  // Admin routes are handled by React Router directly
  if (pathname.startsWith('/sys/wotgate')) return 'admin';
  return PATH_TO_VIEW[pathname] || 'home';
}
